import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPeople2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPeople2"><Path d="M6.5 7.5C6.5 4.46243 8.96243 2 12 2C15.0376 2 17.5 4.46243 17.5 7.5C17.5 10.5376 15.0376 13 12 13C8.96243 13 6.5 10.5376 6.5 7.5Z" fill="currentColor"/><Path d="M3 21V19C3 16.2386 5.23858 14 8 14H16C18.7614 14 21 16.2386 21 19V21C17.8426 21 6.15743 21 3 21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPeople2;
